import { ref, computed } from "vue";
import { defineStore } from "pinia";

export interface AppConfig {
  authUrl: string;
  dashboardApiUrl: string;
  stripe: {
    returnUrl: string;
  },
  extLinks: {
    store: string;
    activateWorkspace: string;
    accountBaseUrl: string;
    oldDashboardBaseUrl: string;
    userProfileBaseUrl: string;
    damsUrl: string;
    supportCenterUrl: string;
    forumUrl: string;
  },
  disableSubscription: boolean;
}

export const useAppConfigStore = defineStore("appConfig", () => {
  const configFilePath = import.meta.env["VITE_APP_CONFIG_PATH"];

  const appConfig = ref(getDefaultValues());

  async function refreshConfig() {
    try {
      const response = await fetch(configFilePath);
      const configContent = await response.json() as AppConfig;
      replaceValuesWhenNotNull(appConfig.value, configContent);
      return true;
    }
    catch (exception) {
      console.warn(`Error loading config from ${configFilePath}\nException: ${exception}`);
      return true;
    }
  }

  function getDefaultValues(): AppConfig {
    return {
      authUrl: import.meta.env["VITE_AUTHENTICATION_URL"] as string,
      dashboardApiUrl: import.meta.env["VITE_DASHBOARD_API_URL"] as string,
      stripe: {
        returnUrl: import.meta.env["VITE_STRIPE_RETURN_URL"] as string
      },
      extLinks: {
        store: import.meta.env["VITE_LINK_ALTIUM_STORE"] as string,
        activateWorkspace: import.meta.env["VITE_LINK_ACTIVATE_WORKSPACE"] as string,
        accountBaseUrl: import.meta.env["VITE_EXT_ACCOUNT_BASE_URL"] as string,
        oldDashboardBaseUrl: import.meta.env["VITE_EXT_DASHBOARD_BASE_URL"] as string,
        userProfileBaseUrl: import.meta.env["VITE_EXT_USER_PROFILE_BASE_URL"] as string,
        damsUrl: import.meta.env["VITE_DAMS_URL"] as string,
        supportCenterUrl: import.meta.env["VITE_EXT_SUPPORT_CENTER_URL"] as string,
        forumUrl: import.meta.env["VITE_EXT_FORUM_URL"] as string,
      },
      disableSubscription: true
    };
  }

  function replaceValuesWhenNotNull(target: { [key: string]: any }, source: { [key: string]: any }) {
    for (const key in target) {
      if (source == null || source[key] == null)
        continue;

      if (typeof target[key] === "object") {
        replaceValuesWhenNotNull(target[key], source[key]);
        continue;

      }
      target[key] = source[key];
    }
  }

  return {
    appConfig: computed(() => appConfig.value),
    refreshConfig
  };
});
